import React from 'react';
import { Col, Container, Row } from 'reactstrap';
import { Link } from 'react-router-dom';

/**
 * The hero.
 *
 * Deliberately does not claim the forecasts are accurate. The research is
 * produced by the visitor's own AI, whichever one they pay for, and it will get
 * better or worse as those models do — that is not ours to promise. What this
 * site provides is the part that is missing when someone asks an AI about a
 * stock: a consistent way to ask, and a record of what was said and whether it
 * held up.
 */
const Home = () => {
    return (
        <React.Fragment>
            <section className="section pb-0 hero-section" id="hero">
                <div className="bg-overlay bg-overlay-pattern"></div>
                <Container>
                    <Row className="justify-content-center">
                        <Col lg={9} sm={11}>
                            <div className="text-center mt-lg-5 pt-5">
                                <h1 className="display-6 fw-semibold mb-3 lh-base">
                                    Keep a real record of your{' '}
                                    <span className="text-success">AI investment research</span>
                                </h1>
                                <p className="lead text-muted lh-base">
                                    You already ask ChatGPT, Claude or Gemini about the market. The
                                    answers are good — and then they are gone, scattered across old
                                    chats, impossible to compare, never checked against what actually
                                    happened.
                                </p>
                                <p className="lead text-muted lh-base">
                                    ForecastNest gives you a structured way to ask, stores exactly
                                    what was asked and when, and turns the outcome into a scorecard
                                    once the horizon closes. Bring any AI you already pay for.
                                </p>

                                <div className="d-flex flex-wrap gap-2 justify-content-center mt-4">
                                    <Link to="/register" className="btn btn-primary">
                                        Start free <i className="ri-arrow-right-line align-middle ms-1"></i>
                                    </Link>
                                    <Link to="/login" className="btn btn-light">
                                        Sign in
                                    </Link>
                                </div>
                                <p className="text-muted fs-13 mt-3 mb-0">
                                    Free to start — no card, and no AI subscription of ours to buy.
                                    You use your own.
                                </p>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>
        </React.Fragment>
    );
};

export default Home;
